import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './Dashboard.css'
import { LeagueSplitView, BannerShimmer, ItemPicker, LoadingState, Modal, ComboBox, ConfirmModal, EmptyState, } from '.././components/Common';
import { map } from 'd3-collection';
import { mean } from 'd3-array';
import Chats, { CreateMessasingModal } from './Chat';
import Squads from '.././components/Squads';
import EventView, { EventViewSplitPane, EventMessageModal, EventMessageView, EventsFilter } from '.././components/Event';
import Documents from '.././components/Documents';
import Games from '.././components/Games';
import Teams from '.././components/Teams';
import AboutView from '.././components/About';
import Training from '.././components/Training';
import GroupEvents, { EventCalenderView, EventAttandence } from '../components/GroupEvents';
import ApplicationForm from '../components/ApplicationForm';
import { ClubStatsView, ClubsView } from './LEAGUE';
import InternalNoticeCenter from '../components/InternalNoticeCenter'

const Trojan = window.Trojan;

export default class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: { id: null },
            activeLabel: "Children",
            activeUser: {
                Children: { id: null },
                Teams: { id: null },
                Clubs: { id: null },
                Institutions: { id: null },
                Tournaments: { id: null },
                Groups: { id: null }
            },
            activeTeam: {
                Children: { id: null },
                Teams: { id: null },
                Clubs: { id: null },
                Institutions: { id: null },
                Tournaments: { id: null },
                Groups: { id: null }
            },
            activeTeams: {
                Children: [],
                Teams: [],
                Clubs: [],
                Institutions: [],
                Tournaments: [],
                Groups: []
            },
            notices:[],
            menuActive: {
                Children: "Calendar",
                Teams: "Calendar",
                Clubs: "Calendar",
                Institutions: "Calendar",
                Tournaments: "Calendar",
                Groups: "Calendar"
            },
            labels: ["Children", "Teams", "Clubs", "Institutions", "Tournaments"/*, "Groups"*/],
            activeTab: null,
            menu: {
                Children: [
                    { text: "Calendar", notices: [] },
                    { text: "Games", notices: [] },
                    { text: "Attendence / Availability", notices: [] },
                    { text: "Information", notices: [] },
                    { text: "Team", notices: [] },
                    { text: "Docs", notices: [] },
                    { text: "Chats", notices: [] },
                ],
                Teams: [
                    { text: "Calendar", notices: [] },
                    { text: "Events", notices: [] },
                    { text: "Games", notices: [] },
                    { text: "Training Material", notices: [] },
                    { text: "Team", notices: [] },
                    { text: "Docs", notices: [] },
                    { text: "Messages", notices: [] },
                    { text: "Notifications", notices: [] },
                    { text: "Inbox", notices: [] },
                ],
                Clubs: [
                    { text: "Calendar", notices: [] },
                    { text: "Events", notices: [] },
                    { text: "Games", notices: [] },
                    { text: "Teams", notices: [] },
                    { text: "Docs", notices: [] },
                    { text: "Messages", notices: [] },
                    { text: "Notifications", notices: [] },
                ],
                Institutions: [
                    { text: "Calendar", notices: [] },
                    { text: "Events", notices: [] },
                    { text: "Games", notices: [] },
                    { text: "Teams", notices: [] },
                    { text: "Docs", notices: [] },
                    { text: "Messages", notices: [] },
                    { text: "Notifications", notices: [] },
                    { text: "Inbox", notices: [] },
                ],
                Tournaments: [
                    { text: "Calendar", notices: [] }, ,
                    { text: "Games", notices: [] },
                    { text: "Standings", notices: [] },
                    { text: "Teams", notices: [] },
                    { text: "Docs", notices: [] },
                    { text: "Notifications", notices: [] },
                    { text: "Inbox", notices: [] },
                ],
                Groups: [
                    { text: "Calendar", notices: [] },
                    { text: "Attendence / Availability", notices: [] },
                    { text: "Information", notices: [] },
                    { text: "Team", notices: [] },
                    { text: "Docs", notices: [] },
                    { text: "Notifications", notices: [] },
                    { text: "Inbox", notices: [] },
                ]
            },
            isFirstTime: true,
            isLoadingTeams: true
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getUser()
    }

    getUser = () => {
        if (!this._isMounted) {
            return;
        }

        const user = FakeData.getData("yoo");
        const _that = this;
        this.setState({ user });

        if (this.state.isFirstTime) {
            const { labels, activeUser } = this.state;
            for (let index = 0; index < labels.length; index++) {
                const element = labels[index];
                if (this.getMenuItems(element).length > 0) {
                    activeUser[element] = this.getMenuItems(element)[0];
                    this.setState({
                        activeUser,
                        activeLabel: element,
                        isFirstTime: false
                    });
                    break;
                }
            }
        }

        setTimeout(() => {
            _that.getUser()
        }, 1000)
    }

    getMenuItems = (key) => {
        const { user, activeLabel } = this.state;
        const _key = key ? key : activeLabel;
        const pages = FakeData.listify(user.pages);
        return pages.filter((item) => {
            return item.dashboardTab === _key;
        })
    }

    render = () => {
        const { user, notices, activeLabel, labels, menu, activeTab, menuActive, activeUser, activeTeams, activeTeam, isLoadingTeams } = this.state;
        const { } = this.props;
        if (user.id === null || activeUser[activeLabel].id === null) {
            return (
                <BannerShimmer />
            );
        }
        return (
            <div data-page="dashboard" className="dashboard-window">
                <div className="dashboard-window-header">
                    <div className="dashboard-window-header-logo">
                        <img src={activeUser[activeLabel].image} />
                    </div>
                    <div className="dashboard-window-header-menu">
                        <div className="dashboard-window-header-menu-label" tabIndex={0} ref={"lblDrop"}>
                            <div className="dashboard-window-header-menu-label-holder">
                                <span>{activeLabel}</span>
                                <i className="material-icons">expand_more</i>
                            </div>
                            <div className="dashboard-window-header-menu-label-dropdown">
                                {
                                    labels.map((item, i) => {
                                        if (this.getMenuItems(item).length === 0) {
                                            return null;
                                        }

                                        return (
                                            <span key={i} onClick={() => {
                                                const _activeTab = menu[item][0].text;
                                                menuActive[item] = menuActive[item] === null ? _activeTab : menuActive[item];
                                                activeUser[item] = activeUser[item].id === null ? this.getMenuItems(item)[0] : activeUser[item];
                                                this.setState({ activeLabel: item, menuActive, activeUser, isLoadingTeams: true });
                                                this.refs['lblDrop'].blur()
                                            }} className={activeLabel === item ? "active" : ""}>{item}</span>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="dashboard-window-header-menu-list">
                            {!isLoadingTeams && activeLabel !== "Teams" &&
                                activeTeams[activeLabel].map((item, i) => {
                                    return (
                                        <div key={i} className="dashboard-window-header-menu-list-item" onClick={() => {
                                            if(FakeData.inArray(activeLabel,["Clubs","Tournaments","Institutions"])){
                                                return;
                                            }
                                            activeTeam[activeLabel] = item;
                                            menuActive[activeLabel] = "Team";
                                            //activeTeams[activeLabel] = [];
                                            this.setState({ menuActive, activeTeam });

                                        }}>
                                            <img src={item.image} style={{ borderRadius: 0 }} />
                                            <span>{item.name}</span>
                                        </div>
                                    );
                                })
                            }
                            {isLoadingTeams && activeLabel !== "Teams" &&
                                <LoadingState isShown={true} style={{ width: "50px", height: "50px", padding: 0 }} spinnerStyle={{ width: "30px", height: "30px" }} />
                            }
                            {!isLoadingTeams && activeLabel !== "Teams" && activeTeams[activeLabel].length === 0 &&
                                <EmptyState isShown={true} style={{ width: "100%", height: "50px", padding: "0 10px", lineHeight: "50px" }} text={"No teams found..."} />
                            }
                        </div>
                    </div>
                    <div className="dashboard-window-header-banner">
                        {
                            this.getMenuItems(activeLabel).map((item, i) => {
                                return (
                                    <div className={activeUser[activeLabel].id === item.id ? "active" : ""} key={i} onClick={() => {
                                        activeUser[activeLabel] = item;
                                        menuActive[activeLabel] = menu[activeLabel][0].text;
                                        activeTeams[activeLabel] = activeTeams[activeLabel];
                                        this.setState({ activeUser, menuActive, activeTeams, isLoadingTeams: true });
                                    }}>
                                        {item.name}
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="dashboard-window-header-nav">
                        {
                            menu[activeLabel].map((item, i) => {
                                return (
                                    <div key={i} onClick={() => {
                                        menuActive[activeLabel] = item.text
                                        this.setState({ menuActive });
                                        //this.refs['lblDrop'].blur()
                                    }} className={menuActive[activeLabel] === item.text ? "active" : ""}>{item.text}</div>
                                )
                            })
                        }
                    </div>
                </div>

                {activeLabel === "Children" &&
                    <ChildrenDashboard isParent={true} key={"child-" + activeUser.Children.id + "-squad-" + activeTeam[activeLabel].squadId + "-team-" + activeTeam[activeLabel].id} child={activeUser.Children} squadId={activeTeam[activeLabel].squadId} teamId={activeTeam[activeLabel].id} active={menuActive.Children} onTeamsChange={(teams = []) => {
                        activeTeams.Children = teams
                        this.setState({ activeTeams, isLoadingTeams: false });
                    }} setNotices={(notices = [])=>{

                    }}/>
                }

                {activeLabel === "Teams" &&
                    <TeamDashboard team={activeUser[activeLabel]} key={"team-" + activeUser.Teams.id} active={menuActive.Teams} />
                }

                {activeLabel === "Clubs" &&
                    <ClubInstDashboard key={"club-" + activeUser.Clubs.id + "-squad-" + activeTeam[activeLabel].squadId + "-team-" + activeTeam[activeLabel].id} club={activeUser.Clubs} squadId={activeTeam[activeLabel].squadId} teamId={activeTeam[activeLabel].id} active={menuActive.Clubs} type={"C"} onTeamsChange={(teams = []) => {
                        activeTeams.Clubs = teams
                        this.setState({ activeTeams, isLoadingTeams: false });
                    }} />
                }

                {activeLabel === "Tournaments" &&
                    <TournDashboard key={"tourn-" + activeUser.Tournaments.id + "-squad-" + activeTeam[activeLabel].squadId + "-team-" + activeTeam[activeLabel].id} tourn={activeUser.Tournaments} squadId={activeTeam[activeLabel].squadId} teamId={activeTeam[activeLabel].id} active={menuActive.Tournaments} type={"L"} onTeamsChange={(teams = []) => {
                        activeTeams.Tournaments = teams
                        this.setState({ activeTeams, isLoadingTeams: false });
                    }} />
                }

                {activeLabel === "Institutions" &&
                    <ClubInstDashboard key={"inst-" + activeUser.Institutions.id + "-squad-" + activeTeam[activeLabel].squadId + "-team-" + activeTeam[activeLabel].id} club={activeUser.Institutions} squadId={activeTeam[activeLabel].squadId} teamId={activeTeam[activeLabel].id} active={menuActive.Institutions} type="I" onTeamsChange={(teams = []) => {
                        activeTeams.Institutions = teams
                        this.setState({ activeTeams, isLoadingTeams: false });
                    }} />
                }

                {activeLabel === "Groups" &&
                    <div className="dashboard-window-content">

                    </div>
                }
            </div>
        )
    }
}

class ChildrenDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            notices: [],
            user: { id: null },
            team: { id: null },
            error: false,
            isLoadingTeam: false,
            teamError: false
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getProfile();
        this.getEvents();
        this.getTeam()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getUnreadNotices = (notices) => {
        const list = []
        FakeData.listify(notices).forEach((item, i) => {
            if (item.context.status === "unread") {
                list.push(item)
            }
        })

        return list;
    }

    getProfile = () => {
        const _that = this;
        const { active, child } = this.props;
        if (!this._isMounted) {
            return
        }
        FakeData.post("/getUserProfile.php?auth0&id=" + child.user + "&them=" + child.user, {}, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }
                if (res.error && _that._isMounted) {
                    _that.setState({
                        error: true
                    });
                } else if (_that._isMounted) {
                    _that.setState({
                        user: res,
                        notices: _that.getUnreadNotices(res.notices)
                    });
                    _that.props.onTeamsChange(res.myTeams);
                    setTimeout((() => {
                        _that.getProfile()
                    }), 5000)
                }
            }),
            error: ((err) => {

            })
        })
    }

    getEvents = () => {
        const _that = this;
        const { active, child } = this.props;
        const dataTo = {
            userId: child.id,
            userToId: child.id,
            userToType: "F",
            teamIds: []
        }

        FakeData.post("/getEventInvites.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }

                res.sort(function (a, b) {
                    return b.timestamp - a.timestamp
                })

                _that.setState({
                    events: res
                })

                setTimeout((() => {
                    _that.getEvents()
                }), 10000)
            }),
            error: ((err) => {
                //
            })
        })
    }

    getTeamIds = () => {
        const teams = FakeData.listify(this.state.user.myTeams);
        const list = [];
        teams.forEach((item, i) => {
            list.push(item.id)
        })

        return list
    }

    getTeam() {
        const _that = this
        const dataTo = {
            user: FakeData.getData('yoo'),
            teamId: this.props.teamId,
            activeSquad: this.props.squadId
        }

        if (!this._isMounted) {
            return
        }

        if (this.props.teamId === null) {
            setTimeout((() => {
                _that.getTeam()
            }), 1000)
            return
        }

        _that.setState({
            isLoadingTeam: true
        });

        FakeData.post("/getTeamProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }

                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoadingTeam: false,
                        teamError: true
                    });
                } else {
                    _that.setState({
                        team: res,
                        isLoadingTeam: false,
                        teamError: false
                    });
                }
            }),
            error: ((err) => {

            })
        })
    }

    render = () => {
        const { active, child, teamId, isParent } = this.props;
        const { user, notices, error, events, team, isLoadingTeam, teamError } = this.state;
        return (
            <div className="dashboard-window-content-children">
                {user.id === null && !error &&
                    <div className="dashboard-window-content-ctx">
                        <LoadingState isShown={true} text={"Loading"} style={{ width: "100%", height: "100%" }} />
                    </div>
                }
                {user.id === null && error &&
                    <div className="dashboard-window-content-ctx">
                        <EmptyState isShown={true} text={"No User Found"} style={{ width: "100%", height: "100%" }} icon={"person"} />
                    </div>
                }

                {user.id !== null && !error && isLoadingTeam &&
                    <div className="dashboard-window-content-ctx">
                        <LoadingState isShown={true} text={"Loading team"} style={{ width: "100%", height: "100%" }} />
                    </div>
                }

                {user.id !== null && !error && teamError && !isLoadingTeam &&
                    <div className="dashboard-window-content-ctx">
                        <EmptyState isShown={true} text={"No Team Found"} style={{ width: "100%", height: "100%" }} icon={"person"} />
                    </div>
                }

                {user.id !== null && !error &&
                    <div className="dashboard-window-content-ctx">
                        {active === "Calendar" &&
                            <GroupEvents isPage={true} pageType={"F"} profile={user} users={[]} events={events.filter((item) => { return item.type !== "Normal" })} isAdmin={false} />
                        }

                        {active === "Attendence / Availability" &&
                            <EventAttandence profile={user} events={events.filter((item) => { return item.type !== "Normal" })} isAdmin={false} isParent={true} />
                        }

                        {active === "Information" &&
                            <ChildBasicInforamation profile={user} isAdmin={isParent} isParent={isParent} />
                        }

                        {active === "Team" && teamId === null &&
                            <EmptyState isShown={true} text={"Select a team"} style={{ width: "100%", height: "100%" }} />
                        }

                        {active === "Team" && teamId !== null && !teamError && !isLoadingTeam &&
                            <Squads isDashboard={true} contentId={this.state.team.id} content={this.state.team} contentType={"T"} sport={this.state.team.sport} squads={this.state.team.squads} isAdmin={false} />
                        }

                        {active === "Docs" &&
                            <Documents isParent={true} toId={FakeData.getData("yoo").id} toType={"F"} profile={user} profileType={child.type} />
                        }

                        {active === "Games" &&
                            <Games teams={this.getTeamIds()} league={false} />
                        }
                        {active === "Chats" &&
                            <Chats isEmbed={true} />
                        }
                    </div>
                }
            </div>
        )
    }
}

export class ChildBasicInforamation extends Component {
    state = {}

    render = () => {
        const { isAdmin, isParent, profile } = this.props;
        const { } = this.state;
        return (
            <div className="child-basic-info">
                <AboutView profile={profile} isParent={isParent} isChildEmbed={true} type="P" state="user" />
            </div>
        )
    }
}

class ChildChatView extends Component {
    state = {}

    render = () => {
        const { isAdmin, isParent, profile } = this.props;
        const { } = this.state;
        const messages = FakeData.listify(profile.messages);
        return (
            <div className="dashboard-window-content-chat-side">
                <div className={"dashboard-window-content-chat-side-head"}>Chats</div>
                <div className={"dashboard-window-content-chat-side-body"}>
                    {messages.length === 0 &&
                        <EmptyState isShown={true} text={"No messages"} icon={"inbox"} style={{ width: "100%", height: "3vh", padding: "5px" }} />
                    }
                </div>
            </div>
        )
    }
}

class TeamDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            notices: [],
            team: { id: null },
            error: false,
            isLoadingTeam: false,
            teamError: false,
            sessions: [],
            sessionFiles: [],
            msgTab: "Applications",
            isEmailing: false
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getProfile();
        this.getEvents();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getUnreadNotices = (notices) => {
        const list = []
        FakeData.listify(notices).forEach((item, i) => {
            if (item.context.status === "unread") {
                list.push(item)
            }
        })

        return list;
    }

    getProfile() {
        const _that = this;
        const { active, team, activeSquad } = this.props;
        if (!this._isMounted) {
            return
        }

        const dataTo = {
            user: FakeData.getData('yoo'),
            teamId: team.id,
            activeSquad: activeSquad
        }

        FakeData.post("/getTeamProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }

                if (res.error) {
                    _that.setState({
                        error: true
                    });
                } else {
                    _that.setState({
                        team: res,
                        //notices: _that.getUnreadNotices(res.join_received)
                    });
                }
                setTimeout((() => {
                    _that.getProfile()
                }), 5000)
            }),
            error: ((err) => {

            })
        })
    }

    getEvents = () => {
        const _that = this;
        const { active, team } = this.props;
        const dataTo = {
            userId: team.id,
            userToId: team.id,
            userToType: "T",
            teamIds: [],
        }

        FakeData.post("/getEvents.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }

                res.sort(function (a, b) {
                    return b.timestamp - a.timestamp
                })

                _that.setState({
                    events: res
                })

                setTimeout((() => {
                    _that.getEvents()
                }), 5000)
            }),
            error: ((err) => {
                //
            })
        })
    }

    getSessions = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.team.id,
                type: "T",
            }
        }

        if (!this._isMounted) {
            return
        }

        FakeData.post("/getSessions.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }
                _that.setState({
                    sessions: res
                })

                setTimeout((() => {
                    _that.getSessions()
                }), 10000)
            }),
            error: ((res) => {
                
            })
        })
    }

    getSingleTeamTeams = (team) => {
        const _list = [];
        const _teams = FakeData.listify(team.squads.current);
        var _thisTeam = team;
        delete _thisTeam.name;
        //console.log(_teams)
        for (let i = 0; i < _teams.length; i++) {
            const item = team.squads.current[i];
            var _team = {};
            for (const key in _thisTeam) {
                if (_thisTeam.hasOwnProperty(key)) {
                    const prop = _thisTeam[key];
                    if (key === "name" || key === "squads" || key === "activeSquad") {
                        continue;
                    } else {
                        _team[key] = prop;
                    }
                }
            }
            //delete _team.name;
            _team['name'] = item.name + " " + item.age;
            _team['activeSquad'] = item;
            //console.log(item.name+" "+item.age)
            _team['players'] = FakeData.listify(item.players);

            if (FakeData.inArray(_team, _list)) {
                continue;
            } else {
                _list.push(_team)
            }
        }
        /*.forEach((item,i)=>{
          const _team = team;
          //console.log(item)
          _team.name = item.name+" "+item.age;
          _team.players = FakeData.listify(item.players);
          _list.push(_team)
        });*/

        return _list;
    }

    render = () => {
        const { active, child, teamId, isParent } = this.props;
        const { user, notices, error, events, team, isLoadingTeam, teamError, sessions, msgTab, isEmailing } = this.state;
        return (
            <div className="dashboard-window-content-children">
                {team.id === null && !error &&
                    <div className="dashboard-window-content-ctx">
                        <LoadingState isShown={true} text={"Loading"} style={{ width: "100%", height: "100%" }} />
                    </div>
                }
                {team.id === null && error &&
                    <div className="dashboard-window-content-ctx">
                        <EmptyState isShown={true} text={"No User Found"} style={{ width: "100%", height: "100%" }} icon={"person"} />
                    </div>
                }

                {team.id !== null && !error && isLoadingTeam &&
                    <div className="dashboard-window-content-ctx">
                        <LoadingState isShown={true} text={"Loading team"} style={{ width: "100%", height: "100%" }} />
                    </div>
                }
                {team.id !== null && !error &&
                    <div className="dashboard-window-content-ctx">
                        {active === "Calendar" &&
                            <GroupEvents isPage={true} pageType={"F"} profile={this.state.team} users={[]} events={events.filter((item) => { return item.type !== "Normal" })} isAdmin={false} />
                        }

                        {active === "Events" &&
                            <EventView isDashboard={true} eventToType="T" eventToID={this.state.team.id} events={this.state.events} profile={this.state.team} />
                        }

                        {active === "Notifications" &&
                            <InternalNoticeCenter hideHeader={true} notices={this.state.team.join_received} profile={this.state.team} type={"T"} />
                        }

                        {active === "Team" && team.id === null &&
                            <EmptyState isShown={true} text={"Select a team"} style={{ width: "100%", height: "100%" }} />
                        }

                        {active === "Training Material" &&
                            <Training sessions={this.state.sessions} files={this.state.sessionFiles} user={this.state.team} userType={"T"} />
                        }

                        {active === "Inbox" &&
                            <Chats isPage={true} isEmbed={true} user={{
                                id: this.state.team.id,
                                type: "T"
                            }} />
                        }

                        {active === "Team" && team.id !== null && !isLoadingTeam &&
                            <Squads isDashboard={true} contentId={this.state.team.id} content={this.state.team} contentType={"T"} sport={this.state.team.sport} squads={this.state.team.squads} isAdmin={false} />
                        }

                        {active === "Docs" &&
                            <Documents teams={this.getSingleTeamTeams(this.state.team)} toId={FakeData.getData("yoo").id} toType={"F"} profile={team} profileType={"T"} />
                        }

                        {active === "Games" &&
                            <Games teams={[team.id]} league={false} />
                        }
                        {active === "Messages" &&
                            <EventViewSplitPane active={this.state.msgTab} items={["Applications", "Team", "Parents", "Messages", "Groups", "Emails"]} setView={(d) => {
                                this.setState({
                                    msgTab: d
                                });
                            }}>
                                {(this.state.msgTab === "Messages") &&
                                    <div className="events-default-view">
                                        <EventMessageView teams={this.getSingleTeamTeams(this.state.team)} label="Chat" eventToType="T" eventToID={this.state.team.id} events={this.state.events} profile={this.state.team} />
                                    </div>
                                }

                                {(this.state.msgTab === "Applications") &&
                                    <ManageApplications team={this.state.team} toType="F" toId={FakeData.getData("yoo").id} events={this.state.events} profile={this.state.team} profileType={"T"} />
                                }

                                {(this.state.msgTab === "Groups") &&
                                    <div className="events-default-view">
                                        <EventMessageView isTeam={false} isParent={false} teams={this.getSingleTeamTeams(this.state.team)} label="Group" eventToType="T" eventToID={this.state.team.id} events={this.state.events} profile={this.state.team} />
                                    </div>
                                }

                                {(this.state.msgTab === "Team") &&
                                    <div className="events-default-view">
                                        <EventMessageView isTeam={true} isParent={false} teams={this.getSingleTeamTeams(this.state.team)} label="Group" eventToType="T" eventToID={this.state.team.id} events={this.state.events} profile={this.state.team} />
                                    </div>
                                }

                                {(this.state.msgTab === "Parents") &&
                                    <div className="events-default-view">
                                        <EventMessageView isTeam={false} isParent={true} teams={this.getSingleTeamTeams(this.state.team)} label="Group" eventToType="T" eventToID={this.state.team.id} events={this.state.events} profile={this.state.team} />
                                    </div>
                                }

                                {(this.state.msgTab === "Emails") &&
                                    <div className="events-default-view">
                                        <EventMessageView teams={this.getSingleTeamTeams(this.state.team)} label="Email" eventToType="T" eventToID={this.state.team.id} events={this.state.events} profile={this.state.team} />
                                    </div>
                                }
                            </EventViewSplitPane>
                        }
                        {isEmailing &&
                            <EventMessageModal teams={this.getSingleTeamTeams(this.state.team)} label="Email" eventToType="T" eventToID={this.state.team.id} events={this.state.events} profile={this.state.team} sendTo={(FakeData.getData("eventMailTo")) ? FakeData.getData("eventMailTo") : {}} value={(FakeData.getData("eventMailTo")) ? FakeData.getData("eventMailTo").email : ""} isOpen={this.state.isEmailing} onClose={() => {
                                this.setState({
                                    isEmailing: false
                                });
                            }} />
                        }
                    </div>
                }
            </div>
        )
    }

}

export class ManageApplications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            applications: [],
            isLoading: true
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getApplications()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getApplications = () => {
        const _that = this;
        const { toId, toType, profile, profileType } = this.props;
        if (!this._isMounted) {
            return
        }
        FakeData.post("/getApplications.php?auth0", {
            user: {
                id: toId,
                type: toType
            },
            userTo: {
                id: profile.id,
                type: profileType
            }
        }, {
                success: ((res) => {
                    if (!_that._isMounted) {
                        return
                    }
                    if (res.error && _that._isMounted) {
                        _that.setState({
                            isLoading: false
                        });
                    } else if (_that._isMounted) {
                        _that.setState({
                            applications: res.data,
                            isLoading: false
                        });
                        setTimeout((() => {
                            _that.getApplications()
                        }), 10000)
                    }
                }),
                error: ((err) => {
                    _that.setState({
                        isLoading: false
                    });
                })
            })
    }


    render = () => {
        const { } = this.props;
        const { isLoading, applications } = this.state;

        applications.sort((a, b) => {
            const a_val = a.isRead ? 1 : 0;
            const b_val = b.isRead ? 1 : 0;
            return b.timestamp - a.timestamp;
        })

        return (
            <div className="team-applications-manage">
                {isLoading &&
                    <LoadingState isShown={true} text={"Loading applications"} style={{ width: "100%", height: "30vw" }} />
                }
                {!isLoading && applications.length === 0 &&
                    <EmptyState isShown={true} text={"No applications found"} style={{ width: "100%", height: "30vw" }} icon={"insert_drive_file"} />
                }
                {!isLoading && applications.length > 0 &&
                    <table className="documents-list table table-hover">
                        <thead className="documents-list-head">
                            <tr>
                                <th>Icon</th>
                                <th>Name</th>
                                <th>Comment</th>
                                <th>Application Type</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody className="documents-list-body">
                            {
                                applications.filter((_item, _i) => {
                                    return true//this.inSport(_item) && this.inTeam(_item) && this.inUser(_item) && this.inTags(_item)
                                }).map((item, i) => {
                                    return (
                                        <ManageApplicationItem key={i} application={item} {...this.props} />
                                    )
                                })
                            }
                        </tbody>
                    </table>
                }
            </div>
        )
    }
}

class ManageApplicationItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }

    render = () => {
        const { application, team } = this.props;
        const { isOpen } = this.state;

        return (
            <tr className="team-applications-manage-item" style={{ fontWeight: application.isRead ? "" : "bold", cursor: "pointer" }}>
                <td>
                    <img src={"images/doc_icon.svg"} style={{ width: "30px", height: "30px" }} />
                </td>
                <td>{application.userTo.name}</td>
                <td>{application.comment.substr(0, 100)}</td>
                <td>{application.applicationType}</td>
                <td>{FakeData.moment(application.date).calendar()}</td>
                <td>
                    <a onClick={() => {
                        this.setState({ isOpen: true });
                    }}>Open</a>
                    {isOpen &&
                        <ViewApplication team={team} application={application} isOpen={isOpen} onClose={() => {
                            this.setState({ isOpen: false });
                        }} />
                    }
                </td>
            </tr>
        )
    }
}

class ViewApplication extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        const { application } = this.props;
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = true;
    }

    render = () => {
        const { application, isOpen, team } = this.props;
        const { } = this.state;
        return (
            <Modal isOpen={isOpen} onClose={this.props.onClose}>
                <div className="add-place" style={{ width: "55vw", height: "85vh", padding: 0, overflow: "auto" }}>
                    <ApplicationForm application={application} isPreview={true} onAccept={this.props.onClose} profile={FakeData.getData("yoo")} {...this.props} isTeam={application.isTeam} team={team} type={"T"} />
                </div>
            </Modal>
        )
    }
}

class ClubInstDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            notices: [],
            club: { id: null },
            team: { id: null },
            error: false,
            isLoadingTeam: false,
            teamError: false,
            msgTab: "Applications",
            isEmailing: false,
            activeTeamTab: "Teams",
            teamTabs: ["Teams", "Players", "Staff Members"],
            currentTeam: { id: null, name: "", players: [], sport: { name: "init" } }
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getProfile();
        this.getEvents();
        this.getTeam()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getUnreadNotices = (notices) => {
        const list = []
        FakeData.listify(notices).forEach((item, i) => {
            if (item.context.status === "unread") {
                list.push(item)
            }
        })

        return list;
    }

    getProfile = () => {
        const _that = this;
        const { active, club } = this.props;
        let dataTo = {

        };

        let url = "";

        if (this.props.type === "C") {
            dataTo = {
                user: FakeData.getData("yoo"),
                clubId: this.props.club.user
            }

            url = "/getClubProfile.php?auth0";
        } else {
            dataTo = {
                user: FakeData.getData('yoo'),
                InstitutionID: this.props.club.user
            }
            url = "/getInstitutionProfile.php?auth0";
        }

        if (!this._isMounted) {
            return
        }

        FakeData.post(url, dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }
                if (res.error && _that._isMounted) {
                    _that.setState({
                        error: true
                    });
                } else if (_that._isMounted) {
                    _that.setState({
                        club: res,
                        notices: _that.getUnreadNotices(res.notices)
                    });
                    _that.props.onTeamsChange(res.teams.current);
                    setTimeout((() => {
                        _that.getProfile()
                    }), 5000)
                }
            }),
            error: ((err) => {

            })
        })
    }

    getEvents = () => {
        const _that = this;
        const { active, club, type } = this.props;
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            userToId: club.id,
            userToType: type,
            teamIds: []
        }

        FakeData.post("/getEvents.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }

                res.sort(function (a, b) {
                    return b.timestamp - a.timestamp
                })

                _that.setState({
                    events: res
                })

                setTimeout((() => {
                    _that.getEvents()
                }), 10000)
            }),
            error: ((err) => {
                //
            })
        })
    }

    getTeamIds = () => {
        const teams = FakeData.listify(this.state.club.teams.current);
        const list = [];
        teams.forEach((item, i) => {
            list.push(item.id)
        })

        return list
    }

    getTeam() {
        const _that = this
        const dataTo = {
            user: FakeData.getData('yoo'),
            teamId: this.props.teamId,
            activeSquad: this.props.squadId
        }

        if (!this._isMounted) {
            return
        }

        if (this.props.teamId === null) {
            setTimeout((() => {
                _that.getTeam()
            }), 1000)
            return
        }

        _that.setState({
            isLoadingTeam: true
        });

        FakeData.post("/getTeamProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }

                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoadingTeam: false,
                        teamError: true
                    });
                } else {
                    _that.setState({
                        team: res,
                        isLoadingTeam: false,
                        teamError: false
                    });
                }
            }),
            error: ((err) => {

            })
        })
    }

    getAllPlayers = (teams = []) => {
        const _p = [];
        teams.forEach((item, i) => {
            const parents = FakeData.listify(item.players);
            if (parents.length > 0) {
                parents.forEach((p, _i) => {
                    if (!FakeData.inArray(p, _p)) {
                        p.teamId = item.id;
                        _p.push(p)
                    }
                })
            }
        })

        return _p;
    }

    getAllRoles = (teams = []) => {
        const { club, notices, error, events, team, isLoadingTeam, teamError, msgTab, isEmailing } = this.state;
        const _p = FakeData.listify(club.roles);

        teams.forEach((item, i) => {
            const _roles = FakeData.listify(item.activeSquad.roles);
            if (_roles.length > 0) {
                _roles.forEach((p, _i) => {
                    if (!FakeData.inArray(p, _p)) {
                        p.teamId = item.id;
                        _p.push(p)
                    }
                })
            }
        })

        return _p;
    }

    removePlayer(item) {
        const _that = this
        const dataTo = {
            player: item,
            user: FakeData.getData("yoo")
        }

        //console.log(dataTo);
        FakeData.post("/removeTeamPlayer.php?auth0", dataTo, {
            success: ((res) => {
                if (!res.status) {
                    var el = document.createElement("div");
                    var id = FakeData.makeid("/removeTeamPlayer.php?auth0".length);
                    el.className = "snack-bar " + id;
                    var sbText = document.createElement("span");
                    sbText.className = "sb-text";
                    el.appendChild(sbText);

                    var sbAction = document.createElement("span");
                    sbAction.className = "sb-action";
                    el.appendChild(sbAction);
                    sbText.textContent = "Could not remove player";
                    sbAction.textContent = "OK";
                    FakeData.setSnack(id, el)
                    _that.setState({
                        isDeletingPlayer: false,
                        playerToDelete: null
                    });
                    return
                } else {
                    FakeData.alert("Player removed!")
                }

                _that.setState({
                    isDeletingPlayer: false,
                    playerToDelete: null
                });
            }),
            error: ((err) => {

            })
        }, true, "", ((res) => {

        }))
    }

    render = () => {
        const { active, teamId, type } = this.props;
        const { club, notices, error, events, team, isLoadingTeam, teamError, msgTab, isEmailing } = this.state;
        return (
            <div className="dashboard-window-content-children">
                {club.id === null && !error &&
                    <div className="dashboard-window-content-ctx">
                        <LoadingState isShown={true} text={"Loading"} style={{ width: "100%", height: "100%" }} />
                    </div>
                }
                {club.id === null && error &&
                    <div className="dashboard-window-content-ctx">
                        <EmptyState isShown={true} text={"No User Found"} style={{ width: "100%", height: "100%" }} icon={"person"} />
                    </div>
                }

                {club.id !== null && !error && isLoadingTeam &&
                    <div className="dashboard-window-content-ctx">
                        <LoadingState isShown={true} text={"Loading team"} style={{ width: "100%", height: "100%" }} />
                    </div>
                }

                {club.id !== null && !error && teamError && !isLoadingTeam &&
                    <div className="dashboard-window-content-ctx">
                        <EmptyState isShown={true} text={"No Team Found"} style={{ width: "100%", height: "100%" }} icon={"person"} />
                    </div>
                }

                {club.id !== null && !error &&
                    <div className="dashboard-window-content-ctx">
                        {active === "Calendar" &&
                            <GroupEvents isPage={true} pageType={type} profile={club} users={[]} events={events.filter((item) => { return item.type !== "Normal" })} isAdmin={club.isAdmin} />
                        }

                        {active === "Events" &&
                            <EventView isDashboard={true} eventToType={type} eventToID={this.state.club.id} events={this.state.events} profile={this.state.club} />
                        }

                        {active === "Inbox" &&
                            <Chats isPage={true} isEmbed={true} user={{
                                id: this.state.club.id,
                                type: type
                            }} />
                        }

                        {active === "Notifications" &&
                            <InternalNoticeCenter notices={this.state.club.join_received} profile={this.state.club} hideHeader={true} type={type} />
                        }

                        {active === "Team" && teamId === null &&
                            <EmptyState isShown={true} text={"Select a team"} style={{ width: "100%", height: "100%" }} />
                        }

                        {active === "Teams" &&
                            <div className="default-view" style={{ backgroundColor: "#fff", marginTop: "10px", paddingBottom: "20px" }}>
                                <div className="view-with-tabs">
                                    {!this.props.isDashboard &&
                                        <div className="view-with-tabs-head">
                                            {
                                                this.state.teamTabs.map((item, i) => {
                                                    return (
                                                        <div key={i} className={(item === this.state.activeTeamTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ activeTeamTab: item })}>{item}</div>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                    <div className="view-with-tabs-body">
                                        {this.state.activeTeamTab === "Teams" && <Teams contentId={this.state.club.id} isDashboard={true} content={this.state.club} contentType={type} sports={FakeData.listify(this.state.club.sports)} teams={this.state.club.teams} isAdmin={this.state.club.isAdmin} />}
                                        {this.state.activeTeamTab === "Players" &&
                                            <div className="events-default-view">
                                                <EventsFilter currentTeam={this.state.currentTeam.id !== null ? this.state.currentTeam : this.state.club.teams.current[0]} onPlayerAdd={(player) => { }} teams={this.state.club.teams.current} players={
                                                    this.getAllPlayers(this.state.club.teams.current).filter((item, i) => {
                                                        if (this.state.currentTeam.id === null) {
                                                            return true;
                                                        } else {
                                                            return item.teamId === this.state.currentTeam.id;
                                                        }
                                                    })
                                                } isPlayerView="true" canAddPlayer="true" onDateSelect={() => { }} onTypeSelect={(team) => {

                                                }} onTeamSelect={(team) => {
                                                    this.setState({ currentTeam: team });
                                                }} />
                                                <table className="event-players">
                                                    <thead>
                                                        <tr>
                                                            <td>Player Name</td>
                                                            <td>DOB</td>
                                                            <td>Position</td>
                                                            <td>Number</td>
                                                            <td>Manage</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.getAllPlayers(this.state.club.teams.current).filter((item, i) => {
                                                                if (this.state.currentTeam.id === null) {
                                                                    return true;
                                                                } else {
                                                                    return item.teamId === this.state.currentTeam.id;
                                                                }
                                                            }).map((item, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td style={{ paddingLeft: "10px" }} className="clickable" onClick={() => {
                                                                            const _that = this
                                                                            FakeData.setData("eventMailTo", item.user);
                                                                            setTimeout(() => {
                                                                                _that.setState({
                                                                                    isEmailing: true
                                                                                });
                                                                            }, 1000)
                                                                        }}>{item.name}</td>
                                                                        <td>DOB</td>
                                                                        <td>{item.position}</td>
                                                                        <td>{item.number}</td>
                                                                        <td className="event-edit-item-actions" style={{ width: "100%" }}>
                                                                            <div className="player_event_delete" style={{ backgroundPosition: "center center" }} onClick={() => {
                                                                                this.setState({
                                                                                    isDeletingPlayer: true,
                                                                                    playerToDelete: item
                                                                                })
                                                                            }}></div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                                {this.state.playerToDelete !== null &&
                                                    <ConfirmModal message="Are you sure you want to remove this player?<br/>" isOpen={this.state.isDeletingPlayer} data={this.state.playerToDelete}
                                                        onOkay={(data) => {
                                                            this.removePlayer(data)
                                                        }}
                                                        onCancel={() => {
                                                            this.setState({
                                                                isDeletingPlayer: false,
                                                                playerToDelete: null
                                                            })
                                                        }} />
                                                }
                                            </div>
                                        }
                                        {this.state.activeTeamTab === "Staff Members" &&
                                            <div className="events-default-view">
                                                <EventsFilter currentTeam={this.state.currentTeam.id !== null ? this.state.currentTeam : this.state.club.teams.current[0]} onPlayerAdd={(player) => { }} teams={this.state.club.teams.current} players={
                                                    this.getAllPlayers(this.state.club.teams.current).filter((item, i) => {
                                                        if (this.state.currentTeam.id === null) {
                                                            return true;
                                                        } else {
                                                            return item.teamId === this.state.currentTeam.id;
                                                        }
                                                    })
                                                } isPlayerView="true" canAddRole="true" onDateSelect={() => { }} onTypeSelect={(team) => {

                                                }} onTeamSelect={(team) => {
                                                    this.setState({ currentTeam: team });
                                                }} />
                                                <table className="event-players">
                                                    <thead>
                                                        <tr>
                                                            <td>Name</td>
                                                            <td>Position</td>
                                                            <td>Manage</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.getAllRoles(this.state.club.teams.current).filter((item, i) => {
                                                                if (this.state.currentTeam.id === null) {
                                                                    return true;
                                                                } else {
                                                                    return item.teamId === this.state.currentTeam.id;
                                                                }
                                                            }).map((item, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td style={{ paddingLeft: "10px" }} className="clickable" onClick={() => {
                                                                            const _that = this
                                                                            FakeData.setData("eventMailTo", item.user);
                                                                            setTimeout(() => {
                                                                                _that.setState({
                                                                                    isEmailing: true
                                                                                });
                                                                            }, 1000)
                                                                        }}>{item.user.name}</td>
                                                                        <td>{item.role}</td>
                                                                        <td className="event-edit-item-actions" style={{ width: "100%" }}>
                                                                            <div className={item.id === 0 ? "player_event_delete disabled" : "player_event_delete"} style={{ backgroundPosition: "center center" }} onClick={() => {
                                                                                if (item.id === 0) {
                                                                                    return;
                                                                                }
                                                                                this.setState({
                                                                                    isDeletingPlayer: true,
                                                                                    playerToDelete: item
                                                                                })
                                                                            }}></div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                                {this.state.playerToDelete !== null &&
                                                    <ConfirmModal message="Are you sure you want to remove this player?<br/>" isOpen={this.state.isDeletingPlayer} data={this.state.playerToDelete}
                                                        onOkay={(data) => {
                                                            this.removePlayer(data)
                                                        }}
                                                        onCancel={() => {
                                                            this.setState({
                                                                isDeletingPlayer: false,
                                                                playerToDelete: null
                                                            })
                                                        }} />
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        {active === "Team" && teamId !== null && !teamError && !isLoadingTeam &&
                            <Squads isDashboard={true} contentId={this.state.team.id} content={this.state.team} contentType={"T"} sport={this.state.team.sport} squads={this.state.team.squads} isAdmin={false} />
                        }

                        {active === "Docs" &&
                            <Documents teams={this.state.club.teams.current} toId={club.id} toType={type} profile={club} profileType={type} />
                        }

                        {active === "Games" &&
                            <Games teams={this.getTeamIds()} league={false} />
                        }

                        {active === "Messages" &&
                            <EventViewSplitPane active={this.state.msgTab} items={["Applications", "Team", "Parents", "Messages", "Groups", "Emails"]} setView={(d) => {
                                this.setState({
                                    msgTab: d
                                });
                            }}>
                                {(this.state.msgTab === "Messages") &&
                                    <div className="events-default-view">
                                        <EventMessageView teams={club.teams.current} label="Chat" eventToType={type} eventToID={this.state.club.id} events={this.state.events} profile={this.state.club} />
                                    </div>
                                }

                                {(this.state.msgTab === "Applications") &&
                                    <ManageApplications team={this.state.club} toType="F" toId={FakeData.getData("yoo").id} events={this.state.events} profile={this.state.club} profileType={type} />
                                }

                                {(this.state.msgTab === "Groups") &&
                                    <div className="events-default-view">
                                        <EventMessageView isTeam={false} isParent={false} teams={club.teams.current} label="Group" eventToType={type} eventToID={this.state.club.id} events={this.state.events} profile={this.state.club} />
                                    </div>
                                }

                                {(this.state.msgTab === "Team") &&
                                    <div className="events-default-view">
                                        <EventMessageView isTeam={true} isParent={false} teams={club.teams.current} label="Group" eventToType={type} eventToID={this.state.club.id} events={this.state.events} profile={this.state.club} />
                                    </div>
                                }

                                {(this.state.msgTab === "Parents") &&
                                    <div className="events-default-view">
                                        <EventMessageView isTeam={false} isParent={true} teams={club.teams.current} label="Group" eventToType={type} eventToID={this.state.club.id} events={this.state.events} profile={this.state.club} />
                                    </div>
                                }

                                {(this.state.msgTab === "Emails") &&
                                    <div className="events-default-view">
                                        <EventMessageView teams={club.teams.current} label="Email" eventToType={type} eventToID={this.state.club.id} events={this.state.events} profile={this.state.club} />
                                    </div>
                                }
                            </EventViewSplitPane>
                        }
                        {isEmailing &&
                            <CreateMessasingModal isCoachView={true} withTopic={true} topic={"General"} withUsers={true} users={[FakeData.getData("eventMailTo")]} teams={club.teams.current} eventToType={type} eventToID={club.id} isOpen={this.state.isEmailing} type={"normal"} onClose={(group) => {
                                if (group === null) {
                                    this.setState({ isEmailing: false });
                                } else {
                                    this.setState({ isEmailing: false });
                                    //this.onGroupAdd(group)
                                }
                            }} />
                        }
                    </div>
                }
            </div>
        )
    }

}

class TournDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            notices: [],
            tourn: { id: null },
            team: { id: null },
            error: false,
            isLoadingTeam: false,
            teamError: false,
            msgTab: "Applications",
            isEmailing: false
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getProfile();
        this.getEvents();
        this.getTeam()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getUnreadNotices = (notices) => {
        const list = []
        FakeData.listify(notices).forEach((item, i) => {
            if (item.context.status === "unread") {
                list.push(item)
            }
        })

        return list;
    }

    getProfile = () => {
        const _that = this;
        const { active, tourn } = this.props;
        let dataTo = {
            user: FakeData.getData("yoo"),
            leagueId: this.props.tourn.id
        };

        if (!this._isMounted) {
            return
        }

        FakeData.post("/getLeagueTournProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }
                if (res.error && _that._isMounted) {
                    _that.setState({
                        error: true
                    });
                } else if (_that._isMounted) {
                    _that.setState({
                        tourn: res,
                        notices: _that.getUnreadNotices(res.notices)
                    });
                    _that.props.onTeamsChange(res.teams.current);
                    setTimeout((() => {
                        _that.getProfile()
                    }), 5000)
                }
            }),
            error: ((err) => {

            })
        })
    }

    getEvents = () => {
        const _that = this;
        const { active, tourn } = this.props;
        const dataTo = {
            userId: FakeData.getData("yoo").id,
            userToId: tourn.id,
            userToType: "L",
            teamIds: []
        }

        FakeData.post("/getEvents.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }

                res.sort(function (a, b) {
                    return b.timestamp - a.timestamp
                })

                _that.setState({
                    events: res
                })

                setTimeout((() => {
                    _that.getEvents()
                }), 10000)
            }),
            error: ((err) => {
                //
            })
        })
    }

    getTeamIds = () => {
        const teams = FakeData.listify(this.state.tourn.teams.current);
        const list = [];
        teams.forEach((item, i) => {
            list.push(item.id)
        })

        return list
    }

    getTeam() {
        const _that = this
        const dataTo = {
            user: FakeData.getData('yoo'),
            teamId: this.props.teamId,
            activeSquad: this.props.squadId
        }

        if (!this._isMounted) {
            return
        }

        if (this.props.teamId === null) {
            setTimeout((() => {
                _that.getTeam()
            }), 1000)
            return
        }

        _that.setState({
            isLoadingTeam: true
        });

        FakeData.post("/getTeamProfile.php?auth0", dataTo, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }

                if (res.error) {
                    _that.setState({
                        error: true,
                        isLoadingTeam: false,
                        teamError: true
                    });
                } else {
                    _that.setState({
                        team: res,
                        isLoadingTeam: false,
                        teamError: false
                    });
                }
            }),
            error: ((err) => {

            })
        })
    }

    render = () => {
        const { active, teamId } = this.props;
        const { tourn, notices, error, events, team, isLoadingTeam, teamError, msgTab, isEmailing } = this.state;
        let type = "L";
        let club = tourn;
        return (
            <div className="dashboard-window-content-children">
                {club.id === null && !error &&
                    <div className="dashboard-window-content-ctx">
                        <LoadingState isShown={true} text={"Loading"} style={{ width: "100%", height: "100%" }} />
                    </div>
                }
                {club.id === null && error &&
                    <div className="dashboard-window-content-ctx">
                        <EmptyState isShown={true} text={"No User Found"} style={{ width: "100%", height: "100%" }} icon={"person"} />
                    </div>
                }

                {club.id !== null && !error && isLoadingTeam &&
                    <div className="dashboard-window-content-ctx">
                        <LoadingState isShown={true} text={"Loading team"} style={{ width: "100%", height: "100%" }} />
                    </div>
                }

                {club.id !== null && !error && teamError && !isLoadingTeam &&
                    <div className="dashboard-window-content-ctx">
                        <EmptyState isShown={true} text={"No Team Found"} style={{ width: "100%", height: "100%" }} icon={"person"} />
                    </div>
                }

                {tourn.id !== null && !error &&
                    <div className="dashboard-window-content-ctx">
                        {active === "Calendar" &&
                            <GroupEvents isPage={true} pageType={"L"} profile={tourn} users={[]} events={events.filter((item) => { return item.type !== "Normal" })} isAdmin={tourn.isAdmin} />
                        }

                        {active === "Teams" &&
                            <ClubsView league={this.state.tourn} onSaveSeason={() => {}} />
                        }

                        {active === "Docs" &&
                            <Documents teams={tourn.teams.current} toId={tourn.id} toType={"L"} profile={tourn} profileType={"L"} />
                        }

                        {active === "Inbox" &&
                            <Chats isPage={true} isEmbed={true} user={{
                                id: this.props.tourn.id,
                                type: "L"
                            }} />
                        }

                        {active === "Notifications" &&
                            <InternalNoticeCenter notices={this.state.tourn.notices} hideHeader={true} profile={this.state.tourn} type={"L"} />
                        }

                        {active === "Standings" &&
                            <ClubStatsView league={tourn} />
                        }

                        {active === "Games" &&
                            <Games teams={this.getTeamIds()} league={tourn.id} />
                        }

                        {active === "Messages" &&
                            <EventViewSplitPane active={this.state.msgTab} items={["Applications", "Team", "Parents", "Messages", "Groups", "Emails"]} setView={(d) => {
                                this.setState({
                                    msgTab: d
                                });
                            }}>
                                {(this.state.msgTab === "Messages") &&
                                    <div className="events-default-view">
                                        <EventMessageView teams={tourn.teams.current} label="Chat" eventToType={type} eventToID={tourn.id} events={this.state.events} profile={tourn} />
                                    </div>
                                }

                                {(this.state.msgTab === "Applications") &&
                                    <ManageApplications team={tourn} toType="F" toId={FakeData.getData("yoo").id} events={this.state.events} profile={tourn} profileType={type} />
                                }

                                {(this.state.msgTab === "Groups") &&
                                    <div className="events-default-view">
                                        <EventMessageView isTeam={false} isParent={false} teams={club.teams.current} label="Group" eventToType={type} eventToID={tourn.id} events={this.state.events} profile={tourn} />
                                    </div>
                                }

                                {(this.state.msgTab === "Teams") &&
                                    <div className="events-default-view">
                                        <EventMessageView isTeam={true} isParent={false} teams={club.teams.current} label="Group" eventToType={type} eventToID={tourn.id} events={this.state.events} profile={tourn} />
                                    </div>
                                }

                                {(this.state.msgTab === "Parents") &&
                                    <div className="events-default-view">
                                        <EventMessageView isTeam={false} isParent={true} teams={club.teams.current} label="Group" eventToType={type} eventToID={tourn.id} events={this.state.events} profile={tourn} />
                                    </div>
                                }

                                {(this.state.msgTab === "Emails") &&
                                    <div className="events-default-view">
                                        <EventMessageView teams={club.teams.current} label="Email" eventToType={type} eventToID={tourn.id} events={this.state.events} profile={tourn} />
                                    </div>
                                }
                            </EventViewSplitPane>
                        }
                        {isEmailing &&
                            <EventMessageModal teams={club.teams.current} label="Email" eventToType={type} eventToID={tourn.id} events={this.state.events} profile={tourn} sendTo={(FakeData.getData("eventMailTo")) ? FakeData.getData("eventMailTo") : {}} value={(FakeData.getData("eventMailTo")) ? FakeData.getData("eventMailTo").email : ""} isOpen={this.state.isEmailing} onClose={() => {
                                this.setState({
                                    isEmailing: false
                                });
                            }} />
                        }
                    </div>
                }
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/pages/Dashboard.js